export default function SupportInfo({ forError }: { forError?: boolean }) {
  const initalMsg = forError
    ? "Si el problema persiste, comunícate "
    : "¿Necesitas ayuda? Comunícate";

  return (
    <p aria-label="Contacto de soporte" className="text-center text-sm text-gray-400" role="note">
      {initalMsg} con soporte al{" "}
      <a
        className="text-[#5D6BE9] underline"
        href="https://wa.me/+5491164370298"
        rel="noreferrer"
        target="_blank"
      >
        +54 9 011 64370298
      </a>
      <br /> o envía un mail a{" "}
      <a
        className="text-[#5D6BE9] underline"
        href="mailto:mesadeayuda@urbetrack.com"
        rel="noreferrer"
        target="_blank"
      >
        mesadeayuda@urbetrack.com
      </a>
      .
    </p>
  );
}
